<template>
  <div
    v-if="show"
    class="open-system-container"
    @touchmove.prevent
  >
    <div class="open-system-block">
      <div
        class="open-system-close"
        @click="closeModal"
      >
        <img src="https://m.hellobike.com/resource/helloyun/08345/bMneu_x9N6.png">
      </div>
      <div class="open-system-title">
        请先升级APP版本
      </div>
      <div class="open-system-word">
        抱歉，您的App版本过低，请前往应用商店，
      </div>
      <div class="open-system-word">
        更新至最新版本
      </div>
      <div
        class="open-read-btn"
        @click="updateApp"
      >
        去更新
      </div>
    </div>
    <div class="shadow" />
  </div>
</template>

<script>
import { isIOS } from '~mall/common/env/env';
// import { UBT } from '@hb/tianqi/lib/ubt.h5'
import nativeMgr from '~mall/common/native/native';

// 常量定义
// const UBT_CONFIG = {
//   pageId: 'couponmall_list',
//   categoryId: 'hellomall',
//   moduleId: 'hellomall_appUpgrade',
//   contentId: 'hellomall_appUpgrade',
//   buttonName: 'hellomall_appUpgrade',
// };

const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/cn/app/true/id1165227346',
  android: 'market://details?id=com.jingyao.easybike',
};

export default {
  name: 'LowVersionModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deviceVersion: '',
    };
  },
  async mounted() {
    await this.initDeviceInfo();
    this.trackModuleExpose();
  },
  methods: {
    /**
     * 初始化设备信息
     */
    async initDeviceInfo() {
      try {
        const { version } = await nativeMgr.getDeviceInfo();
        this.deviceVersion = version || '';
      } catch (error) {
        this.deviceVersion = '';
      }
    },

    /**
     * 追踪模块曝光
     */
    trackModuleExpose() {
      // UBT.moduleExpose({
      //   ...UBT_CONFIG,
      //   exposureTimes: 1,
      //   businessInfo: {
      //     version: this.deviceVersion,
      //   },
      // });
    },

    /**
     * 关闭弹窗
     */
    closeModal() {
      this.$emit('close');
    },

    /**
     * 更新应用
     */
    async updateApp() {
      this.$emit('confirm');
      this.$emit('close');

      this.trackButtonClick();
      this.redirectToAppStore();
    },

    /**
     * 追踪按钮点击
     */
    trackButtonClick() {
      // UBT.clickButton({
      //   pageId: UBT_CONFIG.pageId,
      //   buttonName: UBT_CONFIG.buttonName,
      //   categoryId: UBT_CONFIG.categoryId,
      //   businessInfo: {
      //     version: this.deviceVersion,
      //   },
      // });
    },

    /**
     * 跳转到应用商店
     */
    redirectToAppStore() {
      const url = isIOS ? APP_STORE_URLS.ios : APP_STORE_URLS.android;
      window.location.href = url;
    },
  },
};
</script>

<style lang="less" scoped>
.open-system-container {
  position: fixed;
  bottom: 0;
  z-index: 1000;
  width: 100%;

  .open-system-block {
    width: 100%;
    height: 2.44rem;
    background: #fff;
    border-radius: 0.12rem 0.12rem 0 0;
    z-index: 101;
    position: relative;
    padding-top: 0.2rem;
    display: flex;
    flex-direction: column;

    .open-system-close {
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;

      img {
        width: 0.16rem;
        height: 0.16rem;
        display: block;
      }
    }

    .open-system-title {
      text-align: center;
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
      margin-bottom: 0.24rem;
    }

    .open-system-word {
      text-align: center;
      font-size: 0.14rem;
      font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
      font-weight: 400;
      color: #242729;
      line-height: 0.2rem;

      .orange-word {
        color: #08f;
      }
    }

    .open-read-btn {
      margin: 0.28rem auto 0;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
      width: 3.35rem;
      height: 0.48rem;
      line-height: 0.48rem;
      font-weight: 600;
      color: #fff;
      background: #08f;
      border-radius: 0.48rem;
      text-align: center;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 70%);
    z-index: 100;
  }
}
</style>
